import { Document } from 'mobx-document'
import { Ranking } from '~/models'

export default class RankingDocument extends Document<Ranking> {

  public async performFetch(): Promise<any> {
    throw new Error("Not supported")
  }

}